import { IMobilyticsScenarioFormState } from "./IMobilyticsScenarioFormState";
import { Moment } from "moment";

export interface IMobilyticsScenarioFormProps
  extends IMobilyticsScenarioFormState {
  index: number;
  loading: boolean;
  fillColorHex: string;
  fillOpacity: number;
  canDuplicate: boolean;
  multipleScenarios?: boolean;
  logo: string;
  updateDates: (
    scenarioIndex: number,
    dates: [Moment, Moment],
    dateStrings: [string, string]
  ) => void;
  updateStartTime: (
    scenarioIndex: number,
    time: Moment,
    timeString: string
  ) => void;
  updateEndTime: (
    scenarioIndex: number,
    time: Moment,
    timeString: string
  ) => void;
  toggleAllDayChecked: (scenarioIndex: number) => void;
  toggleMileLimitChecked: (scenarioIndex: number) => void;
  onLessGreaterChange: (scenarioIndex: number, value: string) => void;
  onMilesChange: (
    scenarioIndex: number,
    value: string
  ) => void;
  onDuplicateClick: (index: number) => void;
  onRemoveClick: (index: number) => void;
  onEditTitleSubmit: (index: number, title: string) => void;
  isCustomPolygon: boolean;
}
